<app-navbar></app-navbar>
<main>
  <section class="header relative pt-16 items-center flex mt-36">
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl text-center info-color">Banan Management</h3>
        <p class="text-lg md:text-xl1 mt-4 info-color text-justify  leading-10 px-10 md:px-0">Banan is trusting Service Provider elevates your digital experience with a secure, user-friendly platform designed for seamless interactions. Our cutting-edge encryption technology ensures your sensitive information is protected from unauthorized access, giving you complete peace of mind.
          Take control of your personal data and connect effortlessly with government and private organizations. Say goodbye to the hassle of managing multiple usernames and passwords—Banan simplifies your digital life. Your security and convenience are our priorities.
          </p>
      </div>
    </div>
  </section>


  <section class="relative pb-20">
    <div class="container mx-auto px-4 pb-20 pt-48">
      <div class="items-center flex flex-wrap">
        <div class="w-full md:w-5/12 ml-auto px-8 md:px-4">
          <div class="md:pr-12">
            <h3 class="text-2xl lg:text-3xl font-semibold">Why Choose Banan?</h3>
            <p class="mt-4 text-lg leading-relaxed info-color text-justify">
              Banan transforms your trust service provider experience with a focus on convenience and security. Using cutting-edge encryption, we ensure your sensitive information is protected from unauthorized access. Our platform empowers you to interact seamlessly with government and private establishments while eliminating the hassle of managing multiple usernames and passwords. With an intuitive, user-friendly interface, Banan puts you in control of your personal data and delivers a smarter, stress-free way to manage your trust services.
            </p>
          </div>
        </div>

        <div class="w-3/4 md:w-4/12 ml-auto mr-auto px-4">
          <img alt="..." class="max-w-full rounded-lg shadow-xl mt-4 " src="assets/imges/BANAN_1.png" />
        </div>
      </div>
    </div>
    <div class="container mx-auto px-4">
      <div class="items-center flex flex-wrap">
        <div class="w-3/4 md:w-4/12 ml-auto mr-auto px-4">
          <img alt="..." class="max-w-full rounded-lg shadow-lg mt-4 mb-4" src="assets/imges/BANAN_2.png" />
        </div>
        <div class="w-full md:w-5/12 mx-auto mr-auto px-8 md:px-4">
          <div class="md:pr-12">
            <h3 class="text-2xl lg:text-3xl font-semibold mt-4">How to Get Started with Banan </h3>
            <p class="mt-4 text-lg leading-relaxed info-color text-justify">
              Getting started with Banan is simple and seamless. Follow these three easy steps to unlock the full potential of your trust services:            </p>
  <ul class="mt-6 text-base md:text-lg leading-relaxed list-decimal list-inside text-justify space-y-2">
              <li><strong>	Download the App: </strong> 
                Find the Banan app on your favorite app store—Google Play, Apple App Store, or Huawei App Gallery.</li>
                <li><strong>Verify the Developer: </strong> 
                  Before downloading, ensure the app is published by Banan Trust Service Provider for your security.</li>
              <li><strong>	Register and Explore: </strong> 
                Open the app, register using your phone number, and complete the quick verification process.</li>
            </ul>
            <p class="mt-4 text-base leading-relaxed info-color text-justify">That's it! You're now ready to experience the ease and security of Banan’s features.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer></app-footer>